const regExp = /^[1-9A-Z]{5,20}$/;
const regExpInviteCodeCheck = (str: string) => regExp.test(str);

export { regExpInviteCodeCheck };
